// offline.effects.ts
import { Injectable, inject } from '@angular/core'
import { Actions, createEffect, ofType } from '@ngrx/effects'
import { Store } from '@ngrx/store'
import { of } from 'rxjs'
import { catchError, map, mergeMap } from 'rxjs/operators'
import { OfflineService } from '../../../../../core/connection/offline.service'
import { syncOfflineActions, syncOfflineActionsFailure, syncOfflineActionsSuccess } from '../actions/offline.actions'
import { OfflineState } from '../reducers/offline.reducer'

@Injectable()
export class OfflineEffects {
  private actions$ = inject(Actions)
  private offlineService = inject(OfflineService)
  private store = inject<Store<OfflineState>>(Store)

  public syncOfflineActions$ = createEffect(() =>
    this.actions$.pipe(
      ofType(syncOfflineActions),
      mergeMap(({ actions }) =>
        this.offlineService.syncOfflineActions(actions).pipe(
          map(() => syncOfflineActionsSuccess()),
          catchError((error) => of(syncOfflineActionsFailure({ error }))),
        ),
      ),
    ),
  )
}
